import React, { useContext, useState, useEffect, useRef } from 'react';
import { useForm, Controller } from "react-hook-form";
import Select from 'react-select';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Upload, Modal, message, Radio, DatePicker } from 'antd';
import Checkbox from '@material-ui/core/Checkbox';
// import TimePicker from 'react-time-picker';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import enUS from 'antd/es/locale/en_US';
import arEG from 'antd/es/locale/ar_EG';
import imgupload from '../../Assets/Images/imgupload.png'
import moment from 'moment';
import { LoadingOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import String from '../../Assets/Localization/Local'
import axios from 'axios';
import { API_ENDPOINT } from '../../AppConfig';
import { LangContext, userCookieContext, userSessionContext, userTokenContext } from '../../App';
import { FormContext } from '../../App';
import { Redirect } from 'react-router';
import Snackbar from '@material-ui/core/Snackbar';
import "./styles.css";
import './FieldStyle.css'
import cookie from 'react-cookies'
import useAxios from 'axios-hooks'
import { Link } from 'react-router-dom'
import ConfirmMailCodeModal from './ConfirmMailCodeModal';

import { Req } from '../../Components/Request/request'
import LoadingBar from 'react-top-loading-bar';
import Lottie from 'react-lottie';
import animationData from '../../Assets/lottieFiles/addBtn.json';
import socketIOClient from "socket.io-client"

export const ConfirmCodeModal = React.createContext();

const Field = (props) => {

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  console.log('field props==> ', props)
  const { lang } = useContext(LangContext)
  const { ToggleForm } = useContext(FormContext)
  const { userCookie, handleUserCookie } = useContext(userCookieContext)
  const { userSession, handleUserSession } = useContext(userSessionContext)
  const { userToken, handleUserToken } = useContext(userTokenContext)


  let passwordRef = useRef(null);
  const [fetchedData, setFetchedData] = React.useState({})
  const [previouslang, setPreviouslang] = React.useState({})
  const { disableButton, setDisableButton } = React.useState(false)

  const [inputsField, setInputsField] = React.useState(props.inputs);
  const [redirect, setredirect] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [error, setErrorSnakbar] = React.useState(null);

  const [loadingImg, setLoadingImg] = useState(false);
  const [imgUrl, setImgUrl] = useState('');
  const [imgUploadName, setImgUploadName] = useState('');
  const [RadioBtnValue, setRadioBtnValue] = useState("MALE");
  const [MultiImg_Name, SetMultiImg_Name] = useState('');
  const [previewVisible_multiImg, setPreviewVisible_multiImg] = useState(false);
  const [previewImage_multiImg, setPreviewImage_multiImg] = useState('');
  const [fileList_multiImg, setFileList_multiImg] = useState([]);
  const [Data, setData] = useState({});
  const [object, setObject] = useState({});
  const [showConfirmMail_modal, setShowConfirmMail_modal] = useState(false);
  const [confirmMailData, setConfirmMailData] = useState('');
  const [ConfirmMailDone, setConfirmMailDone] = useState(false);
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, errors, control, watch, setValue, getValues, clearError, setError } = useForm({
    validationSchema: props.validation
  });
  console.log('watch form---> ', watch())
  useEffect(() => {
    if (MultiImg_Name !== '') {
      register({ name: MultiImg_Name })
    }
  }, [MultiImg_Name]);

  useEffect(() => {
    if (props.config.EditForm && props.config.EditForm === true && fetchedData !== {}) {
      initialize()
    }
  }, [fetchedData])

  useEffect(() => {
    if (props.config.EditForm && props.config.EditForm === true) {
      let uri = `${API_ENDPOINT}${props.config.FetchUrl}`
      let token_cookie = cookie.load("HB_token");
      let token_sessionStorage = sessionStorage.getItem("HB_token");

      let token = `Bearer ${token_cookie ? token_cookie : JSON.parse(token_sessionStorage)}`
      console.log('fetch uri and token ==> ', uri, token)

      axios.get(uri, {
        headers: {
          'Authorization': token,
          'Accept-Language': lang
        }
      }).then(response => {
        console.log('fetch data done--> ', response.data)
        setFetchedData(response.data)

      }).catch(error => {
        setLoading(false)
        console.log('fetch data error--> ', error.response)
      })
    }
  }, [])


  const initialize = () => {
    console.log('hello from initialize')

    for (let i = 0; i < props.config.fetchLabels.length; i++) {
      if (props.config.fetchLabels[i] === "date") {
        setValue(props.config.fetchLabels[i], moment(fetchedData[props.config.fetchLabels[i]], 'dd-mm-yyyy'))
      }
      else {
        setValue(props.config.fetchLabels[i], fetchedData[props.config.fetchLabels[i]])
      }
    }
    console.log('watch form11==> ', watch())
  }

  const add = value => {
    setLoadingBarProgress(loadingBarProgress + value)
  };

  const complete = () => {
    setLoadingBarProgress(100)
  };

  const onLoaderFinished = () => {
    setLoadingBarProgress(0)

  };
  const onSubmit = data => {
    setLoading(true)
    // add(30)
    console.log('dddataa==> ', data, getValues())
    // data=getValues()
    // console.log('dddataa==> ', data,getValues())
    const SubmitData = new FormData();
    const NoramlData = {}
    if (props.config.haveImages && props.config.haveImages === true) {
      for (let i = 0; i < props.config.submitLabels.length; i++) {
        console.log('append==> ', props.config.submitLabels[i], data[props.config.submitLabels[i]])

        console.log('append type==> ', typeof data[props.config.submitLabels[i]])
        if (props.config.submitLabels[i] === 'image' || props.config.submitLabels[i] === 'images' || props.config.submitLabels[i] === 'reportImages') {
          let arr = data[props.config.submitLabels[i]];
          for (let j = 0; j < arr.length; j++) {
            console.log('files type==> ',arr[j].originFileObj)
            if( arr[j].originFileObj.type.includes('image')
            // arr[j].originFileObj.name.includes('.pdf') ||
            // arr[j].originFileObj.name.includes('.docx') ||
            // arr[j].originFileObj.name.includes('.doc') ||
            // arr[j].originFileObj.name.includes('.xlsx') ||
            // arr[j].originFileObj.name.includes('.xlsm') ||
            // arr[j].originFileObj.name.includes('.xlsb')
            ){
             
              SubmitData.append(props.config.submitLabels[i], arr[j].originFileObj)
            }else{
              SubmitData.append('files', arr[j].originFileObj)
            }
          }
        }
        else if (props.config.submitLabels[i] === 'listWithUri') {
          for (let j = 0; j < props.config.listWithUri.length; j++) {
            // console.log("values take place ===> uri", props.config.listWithValue[j], data[props.config.listWithValue[j]].value)
            SubmitData.append(props.config.listWithUri[j], data[props.config.listWithUri[j]].id)
          }
        }
        else if (props.config.submitLabels[i] === 'StringData') {
          for (let k = 0; k < props.config.StringData.length; k++) {
            SubmitData.append(props.config.StringData[k].key1, props.config.StringData[k].key2)
          }
        }
        else if (props.config.submitLabels[i] === "gender") {
          if (data[props.config.submitLabels[i]] === undefined) {
            SubmitData.append(props.config.submitLabels[i], "MALE")
          }
          else {
            SubmitData.append(props.config.submitLabels[i], data[props.config.submitLabels[i]])
          }
        }
        else {
          console.log('append11==> ', props.config.submitLabels[i], typeof data[props.config.submitLabels[i]], data[props.config.submitLabels[i]])

          // SubmitData.append(props.config.submitLabels[i],
          //   typeof data[props.config.submitLabels[i]] === "object" ? data[props.config.submitLabels[i]].value : data[props.config.submitLabels[i]])
          SubmitData.append(props.config.submitLabels[i], data[props.config.submitLabels[i]])
        }
      }
    }
    else if (props.config.haveOneImg && props.config.haveOneImg === true) {
      for (let i = 0; i < props.config.submitLabels.length; i++) {

        if (props.config.submitLabels[i] === 'listWithValue') {
          for (let j = 0; j < props.config.listWithValue.length; j++) {
            console.log("values take place ===>", props.config.listWithValue[j], data[props.config.listWithValue[j]].value)
            if (data[props.config.listWithValue[j]] === undefined) {
              setError(props.config.listWithValue[j], 'required', 'kkkk,,,,')
            } else {
              SubmitData.append(props.config.listWithValue[j], data[props.config.listWithValue[j]].value)
            }
          }
        }
        else if (props.config.submitLabels[i] === 'listWithUri') {
          for (let j = 0; j < props.config.listWithUri.length; j++) {
            SubmitData.append(props.config.listWithUri[j], data[props.config.listWithUri[j]].id)
          }
        }
        else if (props.config.submitLabels[i] === 'uploadFiles') {
          for (let j = 0; j < props.config.uploadFiles.length; j++) {
            let tempEle = inputsField.filter(item => item.name === props.config.uploadFiles[j])
            console.log('tempEle--> ', tempEle)
            if (data[props.config.uploadFiles[j]]) {
              console.log('list length==> ', data)
              if (data[props.config.uploadFiles[j]].length === 0 && tempEle.optional === undefined) {
                setError(props.config.uploadFiles[j], 'required', 'it is required*')
              }
              else {
                for (let k = 0; k < data[props.config.uploadFiles[j]].length; k++) {
                  if (data[props.config.uploadFiles[j]][k].status !== 'removed') {
                    SubmitData.append(props.config.uploadFiles[j], data[props.config.uploadFiles[j]][k].originFileObj)
                  }
                }
              }
            }
          }
        }
        else if (props.config.submitLabels[i] === 'StringData') {
          for (let k = 0; k < props.config.StringData.length; k++) {
            SubmitData.append(props.config.StringData[k].key1, props.config.StringData[k].key2)
          }
        }
        else if (props.config.submitLabels[i] === "gender") {
          if (data[props.config.submitLabels[i]] === undefined) {
            SubmitData.append(props.config.submitLabels[i], "MALE")
          }
          else {
            SubmitData.append(props.config.submitLabels[i], data[props.config.submitLabels[i]])
          }
        }
        else {
          SubmitData.append(props.config.submitLabels[i], data[props.config.submitLabels[i]])
        }
      }
    }
    else {
      console.log("data ====>", props.config)
      for (let k = 0; k < props.config.submitLabels.length; k++) {
        NoramlData[props.config.submitLabels[k]] = data[props.config.submitLabels[k]]
      }
    }
    console.log("Post Req Login :", data, NoramlData)

    if (props.config !== undefined) {
      for (let parts of SubmitData.entries()) {
        console.log('parts==> ', parts[0], '  +  ', parts[1])
      }
      if (props.config.loginFlag !== undefined || props.config.loginFlag === true) {
        AuthPostAxios(props.config.url, data)
      }
      else if (props.config.signUpFlag !== undefined && props.config.signUpFlag === true) {
        SubmitData.append("countryCode", "20")
        SubmitData.append("countryKey", "EG")
        console.log('data sign up==> ', data)
        AuthPostAxios(props.config.url, SubmitData)
      }
      else {
        if ((props.config.haveImages && props.config.haveImages === true) || (props.config.haveOneImg && props.config.haveOneImg === true)) {
          // for (let parts of SubmitData.entries()) {
          //   console.log('parts==> ', parts[0], '  +  ', parts[1])
          // }
          postAxios(props.config.url, SubmitData)
        }
        else {
          console.log('send Noraml data=> ', props.config.url, data)
          postAxios(props.config.url, data)
        }
      }
    }

  };

  const AuthPostAxios = (url, data) => {
    // add(50)
    axios.post(`${API_ENDPOINT}${url}`, data,
      {
        headers: {
          "Accept-Language": lang,
          "Content-Type": "application/json"
        }
      }
    ).then(response => {
      console.log("Post Req Login :", response.data)
      complete()
      const socket = socketIOClient('https://www.health-book.net:3000/utils', {
        query: {
          id: response.data.user.id
        }
      });
      console.log("theSocket", socket);
      if (props.config.signUpFlag !== undefined && props.config.signUpFlag === true) {
        cookie.save("HBUser", response.data.user, { path: '/' })
        cookie.save("HB_token", response.data.token, { path: '/' })
        handleUserCookie()
        handleUserToken(response.data.token)
      }
      else {
        if (data.rememberMe === true) {
          //save in cookies
          cookie.save("HBUser", response.data.user, { path: '/' })
          cookie.save("HB_token", response.data.token, { path: '/' })
          handleUserCookie()
          handleUserToken(response.data.token)
        }
        else {
          // save in session
          sessionStorage.setItem("HBUser", JSON.stringify(response.data.user))
          sessionStorage.setItem("HB_token", JSON.stringify(response.data.token))
          let getData = JSON.parse(sessionStorage.getItem("HBUser"))
          console.log('session data===> ', getData)
          handleUserSession()
          handleUserToken(response.data.token)
        }
      }
      if (props.config.redirectflag) {
        setredirect(true)
      } else {
        ToggleForm()
      }
    })
      .catch(error => {
        setLoading(false)
        console.log("Error Login :", error.response, error.response.data.errors)
        setOpen(true);
        if (!error.response) {
          setErrorSnakbar("Network Error")
        }
        else if (error.response.status === 422) {
          for (let i = 0; i < error.response.data.errors.length; i++) {
            setErrorSnakbar(error.response.data.errors[i].msg)
          }
        }
        else {
          setErrorSnakbar(error.response.data.errors)
        }
      })
  }
  const disabledDate = (current) => {
    var now = new Date()
    var year = now.getFullYear()
    var month = now.getMonth() + 1
    var day = now.getDate() + 1
    let customDate = `${year}-${month}-${day}`
    return current && current >= moment(customDate, "YYYY-MM-DD");
  }
  const postAxios = (url, data) => {
    axios(50)
    let token_cookie = cookie.load("HB_token");
    let token_sessionStorage = sessionStorage.getItem("HB_token");
    let token = `Bearer ${token_cookie ? token_cookie : JSON.parse(token_sessionStorage)}`

    console.log('Req Post url Field file===> ', `${API_ENDPOINT}${url}`, data, token)
    axios.post(`${API_ENDPOINT}${url}`, data,
      {
        headers: {
          "Accept-Language": lang,
          "Content-Type": "application/json",
          Authorization: token
        }
      }
    ).then(response => {
      console.log("Req Post done Field file:", response.data)
      complete()
      setLoading(false)
      if (url === "/contactUs" || url === "/contactUs/token") {
        setOpen(true);
        setErrorSnakbar(lang === "ar" ? "تم ارسال الرسالة بنجاح" : "Send Message Successfully")
      }

      if (props.config.redirectflag) {
        setredirect(true)
      }
    })
      .catch(error => {
        console.log("Post Req Error Field file :", error.response)
        setLoading(false)
        complete()
        console.log("Post Req Error :", error)
        setOpen(true);
        if (!error.response) {
          setErrorSnakbar("Network Error")
        }
        else if (error.response.status === 422) {
          for (let i = 0; i < error.response.data.errors.length; i++) {
            setErrorSnakbar(error.response.data.errors[i].msg)
          }
        }
        else if (error.response.status === 401) {
          setErrorSnakbar(lang === "ar" ? "من فضلك قم بتسجيل الدخول" : "Please Login first")

        }
        else {
          setErrorSnakbar(error.response.data.errors)
        }
      })
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false)
  };

  //************************************************** */

  const SendMail = () => {
    add(50)
    console.log('hello')

    let uri = `${API_ENDPOINT}${props.config.sendEmail}`
    let values = getValues();
    let data = {}
    data[props.config.sendMail_Label[0]] = values[props.config.sendMail_Label[1]]

    console.log('SendMail uri==> ', uri, data)
    axios.post(uri, data, {
      headers: {
        'Content-Type': "application/json"
      }
    }).then(response => {
      complete()
      console.log('SendMail done===> ', response.data)
      setConfirmMailData(values[props.config.sendMail_Label[1]])
      setShowConfirmMail_modal(!showConfirmMail_modal)

    }).catch(error => {
      complete()
      setLoading(false)
      setOpen(true);
      console.log('SendMail error===> ', error.response.status === 403, error.response.status, error.response, error.response.data.errors)
      if (!error.response) {
        setErrorSnakbar("Network Error")
      }
      else if (error.response.status === 422) {
        for (let i = 0; i < error.response.data.errors.length; i++) {
          setErrorSnakbar(error.response.data.errors[i].msg)
        }
      }
      else if (error.response.status === 403) {
        setErrorSnakbar(error.response.data.errors)
      }
      else {
        setErrorSnakbar(error.response.data.errors)
      }
    })
  }

  const handleModalCancel = () => {
    setShowConfirmMail_modal(!showConfirmMail_modal)
  }
  const HandleConfirmMailDone = (str) => {
    setConfirmMailDone(str)
  }
  const confirmMailCode = () => {

    let uri = `${API_ENDPOINT}${props.config.confirmMail}`
    let values = getValues();
    let data = {}
    data[props.config.confirmMail_label[0]] = values[props.config.confirmMail_label[1]]

    console.log('confirmMailCode uri==> ', uri, data)
    axios.put(uri, data, {

      headers: {
        'Content-Type': "application/json"
      }
    }).then(response => {
      complete()
      console.log('confirmMailCode done=> ', response.data)

    }).catch(error => {
      complete()
      setLoading(false)
      console.log('confirmMailCode error=> ', error.response)
    })
  }

  //************************************************** */

  const InputhandleChange = (limit, type, e, name) => {
    var numbers = /^[0-9]+$/;
    if (limit) {
      if (type === "number") {
        console.log("numbers ==>", e.target.value.length, limit, type, e.target.value.length <= limit)

        if (e.target.value.length <= limit && numbers.test(e.target.value)) {
          setValue(name, e.target.value)
        } else {
          let obj = getValues()
          console.log("numbers ==> inelse", getValues(), obj[name].slice(0, -1))
          setValue(name, obj[name].slice(0, -1))
        }

      }

    } else {
      if (type === "number") {
        console.log("numbers ==>", e.target.value)
        if (numbers.test(e.target.value)) {
          setValue(name, e.target.value)
        } else {
          let obj = getValues()
          console.log("numbers ==> inelse", getValues(), obj[name].slice(0, -1))
          setValue(name, obj[name].slice(0, -1))
        }

      }

    }

  }
  // ************************************************** /
  const TextFieldInput = (element, register, errors, lang) => {

    return (
      <Col lg={element.col ? element.col : '12'} style={element.colStyle && element.colStyle}>
        <div className="textWithIcon">
          {/* {console.log("test case ===>", element.name, object[`${element.name}`])} */}
          {element.label && <label >{element.label[lang]}</label>}

          <input type={element.type} name={element.name}
            onChange={(e) => InputhandleChange(element.limit, element.inputType, e, element.name)}
            ref={register}
            placeholder={element.placeholder[lang]} className="textStyleWithIcon px-4"
            style={element.inputStyle && element.inputStyle} />

          {element.isPassword && element.isPassword === true ?
            <Link
              onClick={() => element.type === 'password' ? element.type = 'text' : element.type = 'password'}
              className="TextFieldIconLink"
              style={{ right: lang === 'en' ? '1.5rem' : '', left: lang === 'ar' ? '1.5rem' : '', background: 'transparent', border: 'none', padding: '0px', outline: 'none' }}>
              <i className={element.type === 'password' ? element.icon[0] : element.icon[1]}> </i>
            </Link>
            :
            element.confirmBtn ?
              ConfirmMailDone === false ?
                <Link
                  onClick={SendMail}
                  className="confirmSpan"
                  style={{ right: lang === 'en' ? '4%' : '', left: lang === 'ar' ? '4%' : '' }} >
                  {element.confirmBtn[lang]}
                </Link>
                :
                <span className="TextFieldIcon" style={{ right: lang === 'en' ? '1.5rem' : '', left: lang === 'ar' ? '1.5rem' : '', color: '#0fe00f' }}>
                  <i className="fa fa-check-double"></i>
                </span>
              :
              <span className="TextFieldIcon" style={{ right: lang === 'en' ? '1.5rem' : '', left: lang === 'ar' ? '1.5rem' : '' }}>
                <i className={element.icon}> </i>
              </span>
          }
        </div>
        {console.log("errors take place ==>", errors[element.name], lang, errors[element.name] ? errors[element.name]["message"][lang] : "")}
        {errors[element.name] && <p className="ErrorStyle px-3">{errors[element.name]["message"][lang]}</p>}
      </Col>
    )
  }

  //*************************************** */
  const CheckboxInput = (element, lang) => {
    let tempObj = watch();
    // let tempObj=control.getValues();
    return (
      <Col lg={element.col ? element.col : '12'}>
        <p style={{ textAlign: lang === 'ar' ? 'right' : 'left', color: tempObj[element.name] === true ? 'orange' : '#747474' }} className="checkbox-inputStyle">
          <Checkbox inputRef={register} name={element.name} />
          {element.label[lang]}
        </p>
      </Col>
    )
  }
  //*************************************** */

  const TextAreaInput = (element, register, errors, lang) => {
    return (
      <div className="w-100">
        <textarea
          style={element.textAreaStyle ? element.textAreaStyle : ""}
          class="form-control"
          rows="3"
          ref={register}
          name={element.name}
          placeholder={element.placeholder[lang]}></textarea>
        {errors[element.name] && <p className="ErrorStyle px-3">{errors[element.name]["message"][lang]}</p>}
      </div>
    )
  }
  //*************************************** */

  function fetchOptions(element, lang) {
    element.flag = true
    let data = [], info = []
    let uri = `${API_ENDPOINT}${element.uri}`

    console.log('fetchOptions uri=> ', uri)
    axios.get(uri, {
      headers: {
        'Accept-Language': lang
      }
    }).then(response => {
      console.log('fetchOptions response===> ', response.data.data)
      info = response.data.data;
      for (let i = 0; i < info.length; i++) {
        let tempObj = {}
        tempObj.value = info[i].name;
        tempObj.label = info[i].name;
        tempObj.id = info[i].id;
        data.push(tempObj)
      }
      console.log('ddd==> ', data)
      var opt = Data;
      opt[element.name] = data;
      console.log('list items state-------> ', element.name, opt)
      setData(opt)

    }).catch(error => {
      console.log('fetchOptions error===> ', error)
    })
  }

  const SelectWithOptions = (element, register, errors, lang) => {
    console.log("call use effect ==>uri in element ===>", element)
    if (element.uri && !element.flag) {
      let URI = `${API_ENDPOINT}${element.uri}`

      Req(URI, lang).then(
        res => {
          element.flag = true
          let data = [], info = []
          console.log("call use effect ==>", res.data.data)
          info = res.data.data;
          for (let i = 0; i < info.length; i++) {
            let tempObj = {}
            tempObj.value = info[i].name;
            tempObj.label = info[i].name;
            tempObj.id = info[i].id;
            data.push(tempObj)
          }
          element.options = data
          setData(element)
        }
      )
        .catch(error => {
        })
    }

    console.log("SelectWithOptions ==>", element, element.options, element.flag, Data)
    return (
      <Col lg={element.col ? element.col : '12'} style={element.colStyle && element.colStyle}>
        <div>
          <Controller
            as={<Select
              options={element.flag ? element.options : typeof element.options === 'object' ? element.options[lang] : element.options} />}
            isMulti={element.multiOptions === true ? true : false}
            control={control}
            rules={{ required: true }}
            placeholder={element.placeholder ? element.placeholder[lang] : 'select'}
            onChange={([selected]) => {
              console.log("selected ==>", selected, element)
              // inputsField
              setValue(element.name, selected.id)
              if (element.name === "animalType") {
                setValue(inputsField[3].name, null)
                inputsField[3].uri = `/bloodType?animalType=${selected.id}`
                inputsField[3].flag = false
                inputsField[3].options = []
                setInputsField(inputsField)
                setData(inputsField)
              }
              return selected;
            }}
            name={element.name}
            ref={register({ required: true })}
          />
        </div>
        <div>
          {errors[element.name] && <p className="ErrorStyle px-3">{errors[element.name]["message"][lang]}</p>}

        </div>
      </Col>
    )
  }
  //*************************************** */

  const handleChange_imgUpload = (info, element) => {
    console.log('img--> ', info)
    if (info.file.status === 'uploading') {
      setLoadingImg(true)
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setLoadingImg(false)
        setImgUrl(imageUrl)
        register({ name: element.name });
        setValue(element.name, info.file.originFileObj);
        clearError(element.name)
      }
      );
    }
  };

  const SelectOneImg = (element, errors) => {
    const uploadButton = (
      <div>
        {loadingImg === true ? <LoadingOutlined /> : <PlusOutlined />}
        <div className="ant-upload-text">{String.upload}</div>
      </div>
    );
    let watchEle = watch(element.name);
    // console.log('watch value of image--> ', watch(element.name) === undefined)
    return (
      <Col lg="12" className="UploadImgCol">
        <div className="uploadImgDiv" style={element.uploadImgDivStyle}>
          <Upload
            name={element.name}
            listType="picture-card"
            className={watchEle === undefined ? "avatar-uploader uploadIMG" : "avatar-uploader appear"}
            showUploadList={false}
            // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            customRequest={dummyRequest}
            beforeUpload={beforeUpload}
            // beforeUpload={() => false}
            onChange={(e) => handleChange_imgUpload(e, element)}
            style={{ background: 'red' }}
          >
            {imgUrl !== '' ? <img src={imgUrl} alt="avatar" /> : uploadButton}
          </Upload>
          {imgUrl === '' && <img className="imguploadicon" src={imgupload} alt="imgupload" style={{ opacity: watchEle === undefined ? '1' : '0' }} />}
        </div>
        <span style={{ marginBottom: '80px' }}>
          <div className="Upload_Img_Title">
            {element.title && <h5>{element.title[lang]}</h5>}
            {element.subTitle && <h6>{element.subTitle[lang]}</h6>}
          </div>
          {errors[element.name] && <p className="ErrorStyle px-3 text-center">{errors[element.name]["message"][lang]}</p>}
        </span>
      </Col>
    );
  }

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  }
  //*************************************** */

  function getBase64_multiImg(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  const handleCancel = () => {
    setPreviewVisible_multiImg(false);
  }
  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64_multiImg(file.originFileObj);
    }
    setPreviewVisible_multiImg(true);
    setPreviewImage_multiImg(file.url || file.preview)
  };

  const handleSelect_MultiImg = (file, element) => {
    console.log('file lisy=--> ', file)
    SetMultiImg_Name(element.name)
    setFileList_multiImg(file.fileList)
    setValue(element.name, file.fileList);
  }
  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const SelectMultiImg = (element, errors) => {

    const uploadButton = (
      <div className="upladIamgAvatar" >
        <img className="imguploadicon" src={imgupload} alt="imgupload" style={{ position: 'absolute', top: '-200px', left: '50%' }} />
      </div>
    );

    return (
      <Col lg={element.col ? element.col : '12'} className="UploadImgCol">

        <div className=" uploadImgDivMultiImg">
          <Upload
            // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            // listType="picture-card"
            customRequest={dummyRequest}
            fileList={fileList_multiImg}
            onPreview={handlePreview}
            onChange={(e) => handleSelect_MultiImg(e, element)}
            // beforeUpload={() => false}
            name={element.name}
            style={{ opacity: '0' }}
          >
          {fileList_multiImg.length >= 8 ? null : uploadButton}
          </Upload>
        <Modal visible={previewVisible_multiImg} footer={null} onCancel={handleCancel}>
          <img alt="example" style={{ width: '100%' }} src={previewImage_multiImg} />
        </Modal>
        </div>
      <div className="Upload_Img_Title" style={{
      }}>
        {element.title && <h5>{element.title[lang]}</h5>}
        {element.subTitle && <h6>{element.subTitle[lang]}</h6>}
      </div>
      <div>
        {errors[element.name] && <p className="ErrorStyle px-3 text-center">{errors[element.name]["message"] ? errors[element.name]["message"][lang] : ""}</p>}
      </div>
      </Col >
    );
  }

//*************************************** */

const handleUploadFile = (fileInfo, element, errors) => {

  console.log('fileInfo==> ', fileInfo, element, errors)

  if (fileInfo.fileList.length <= 0) {
    setError(element.name, 'upload file is reqquired ')
  }
  if (fileInfo.file.status !== 'uploading') {
    console.log(fileInfo.file, fileInfo.fileList);
  }
  if (fileInfo.file.status === 'done') {
    message.success(`${fileInfo.file.name} file uploaded successfully`);
    register({ name: element.name })
    setValue(element.name, fileInfo.fileList)
    clearError(element.name)
    console.log('fileInfo==> ', errors)
  } else if (fileInfo.file.status === 'error') {
    message.error(`${fileInfo.file.name} file upload failed.`);
  }
}

const UploadFile = (element, errors, lang) => {

  console.log('errors---> ', errors)
  let title = element.placeholder[lang]
  return (
    <Col lg={element.col ? element.col : '12'} style={element.colStyle && element.colStyle}>
      <Upload
      
        name={element.name}
        ref={register({ required: true })}
        onChange={(e) => {
          console.log('eeeee==> ', e)
          handleUploadFile(e, element, errors)
        }}
        // beforeUpload={() => false}
        // action='https://www.mocky.io/v2/5cc8019d300000980a055e76'
        customRequest={dummyRequest}
        
        >
        <Button>
          <UploadOutlined /> {title}
        </Button>
      </Upload>

      <div>
        {errors[element.name] && <p className="ErrorStyle px-3">{errors[element.name]["message"] ? errors[element.name]["message"][lang] : ""}</p>}
      </div>

    </Col >
  )
}

//*************************************** */
const HandleRadiobtn = (e, element) => {
  console.log('radio btn---> ', e.target.value)
  setRadioBtnValue(e.target.value)
  register({ name: element.name })
  setValue(element.name, e.target.value)

}

const RadioBtn = (element, register, errors, lang) => {

  return (
    <Col lg={element.col ? element.col : '12'} style={element.colStyle && element.colStyle}>
      <Row className="RadioBtn" style={element.subRowStyle && element.subRowStyle}>
        <Col lg="6" md="6" >
          <h6 className="title">{element.title[lang]}</h6>
        </Col>
        <Col lg="6" md="6">
          <Radio.Group onChange={(e) => HandleRadiobtn(e, element)} value={RadioBtnValue} name={element.name} ref={register}>
            {element.values.map((valueItem, index) => {
              console.log("items ===>", valueItem)
              return (
                <Radio value={valueItem.id} name={element.name} checked="checked">{valueItem[lang]}</Radio>
              )
            })}
          </Radio.Group>
        </Col>
      </Row>
      {console.log('...ekfeifj=> ', getValues(`${element.name}`))}
      <div>
        {errors[element.name] && <p className="ErrorStyle px-3">{errors[element.name]["message"][lang]}</p>}
      </div>
    </Col>

  )
}

//*************************************** */

const handleSelectedDate = (data, register, element) => {
  console.log('selected date--> ', data, element);
  register({ name: element.name })
  if (data) {
    setValue(element.name, data._d)
    setError(element.name, null)
  }
  else {
    setValue(element.name, null)
    setError(element.name, { ar: "يجب اختيار التاريخ  *", en: "Date is required *" })
  }
}

const SelectDate = (element, register, lang) => {
  console.log('selected date-->selected date-->selected date-->-> ', element)
  return (
    <Col lg={element.col ? element.col : '12'} md="12" sm="12" className="DatePickerCol" style={element.colStyle && element.colStyle}>
      <DatePicker
        ref={register}
        disabledDate={disabledDate}
        placeholder={String.SelectDate}
        onChange={(e) => handleSelectedDate(e, register, element)}
        // defaultValue={moment('12-02-2020', 'dd-mm-yyyy')}
        className="DatePickerStyle" locale={lang === "ar" ? arEG : enUS} />
      <div>
        {console.log("Date picker ====>")}
        {errors[element.name] && <p className="ErrorStyle px-3">{errors[element.name]["message"] ? errors[element.name]["message"][lang] : ""}</p>}
        {errors[element.name] && <p className="ErrorStyle px-3">{errors[element.name]["types"] ? errors[element.name]["types"][lang] : ""}</p>}

      </div>
    </Col>
  )
}

//*************************************** */

const handleSelectedtime = (data) => {
  console.log('selected time ==> ', data)
}
const SelectTime = (element, lang) => {
  console.log('control===> ', control)

  return (
    <Col lg={element.col ? element.col : '12'} >
      <div>
        {/* <TimePicker placeholder="Select a time" /> */}
        <Controller
          as={<TimePicker />}
          name={element.name}
          control={control}
          // placeholder="Select a time"
          defaultValue={moment('13:30:56', 'HH:mm:ss')}
          onChange={handleSelectedtime}
        />
      </div>
    </Col>
  )
}
//*************************************** */
if (redirect) {
  console.log('redirectState field=> ', props.config.redirectState)
  if (props.config.redirectState) {
    return <Redirect to={{
      pathname: props.config.redirect,
      state: props.config.redirectState
    }} />

  } else {
    return <Redirect to={props.config.redirect} />
  }
}
// console.log("object take place ===>",object)
return (
  <div>
    <div style={{ width: "100%", position: "absolute", top: "0px" }}>
      <LoadingBar
        progress={loadingBarProgress}
        height={3}
        color='#f49a31'
        onLoaderFinished={() => onLoaderFinished()}
      />
    </div>
    <div style={{ width: "100%", position: "absolute", bottom: "0px" }}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} message={error} />
    </div>
    {console.log("data take place", Data)}
    <form onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: '100%', position: 'relative' }} autocomplete="off">

      <Container>
        <Row className="UploadImgRow m-0 p-0">
          {props.ImageUpload && props.ImageUpload.map((ImgEle, index) => {
            return (
              SelectOneImg(ImgEle, errors)
            )
          })}
          {
            props.UploadmultiImg && props.UploadmultiImg.map((imgEle, index) => {
              return (
                SelectMultiImg(imgEle, errors)
              )
            })
          }
        </Row>
      </Container>
      <Container className="FieldResponsive" style={props.FieldsContainerStyle && props.FieldsContainerStyle}>
        <Row>
          {/* {console.log("inputsField====>", inputsField)} */}
          {inputsField.map((element, index) => {
            return (
              element.type === "text" || element.type === "email" || element.type === 'password' ?
                TextFieldInput(element, register, errors, lang)
                :
                element.type === "checkbox" ?
                  CheckboxInput(element, lang)
                  :
                  element.type === 'textarea' ?
                    TextAreaInput(element, register, errors, lang)
                    :
                    element.type === "date" ?
                      SelectDate(element, register, lang)
                      :
                      element.type === "time" ?
                        SelectTime(element, lang)
                        :
                        element.type === 'SelectWithOptions' ?
                          SelectWithOptions(element, register, errors, lang)
                          :
                          element.type === 'uploadFile' ?
                            UploadFile(element, errors, lang)
                            :
                            element.type === 'submitBtn' ?
                              <Col lg={element.col ? element.col : '12'}>
                                {
                                  loading ?
                                    <div style={props.dimButton && props.dimButton} className="text-center">

                                      <Lottie options={defaultOptions}
                                        height={50}
                                        width={50}
                                      />
                                    </div>
                                    :
                                    <Button type="submit" style={element.submitBtnStyle && element.submitBtnStyle} >

                                      {element.fromcontactus ? String.sendbtn : String.AddBtn}
                                    </Button>
                                }
                              </Col>
                              :
                              element.type === 'radio' ?
                                RadioBtn(element, register, errors, lang)
                                :
                                <div className="">
                                  <input type={element.type} name={element.name} ref={register} placeholder={element.placeholder[lang]} className="" />
                                  {errors[element.name] && <p>{errors[element.name]["message"][lang]}</p>}
                                </div>
            )
          })}
        </Row>
      </Container>
      <Container>
        <Row>
          <Col lg="12" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {props.innerSubmitBtn && props.innerSubmitBtn === true ? '' :
              loading ?
                <div style={props.dimButton && props.dimButton} className="text-center">

                  <Lottie options={defaultOptions}
                    height={50}
                    width={50}
                  />
                </div>
                :
                <Button type="submit" style={props.SubmitBtnStyle && props.SubmitBtnStyle} >
                  {/* {props.config && props.config.Sendbtn ?
                      props.config.Sendbtn[lang]
                      :
                      props.config.fromcontactus? String.sendbtn:
                      String.AddBtn
                    } */}
                  {
                    props.config && props.config.fromcontactus ? String.sendbtn :
                      props.config.Sendbtn ?
                        props.config.Sendbtn[lang]
                        : String.AddBtn
                  }
                  {console.log("Add btn:", props.config)}
                </Button>
            }
          </Col>
        </Row>
      </Container>
    </form>
    {showConfirmMail_modal === true &&
      <ConfirmCodeModal.Provider value={{ show: showConfirmMail_modal, handleModalCancel: handleModalCancel, HandleConfirmMailDone: HandleConfirmMailDone }}>
        <ConfirmMailCodeModal mail={confirmMailData} />
      </ConfirmCodeModal.Provider>
    }
  </div >
);
}
export default Field